module.exports = __webpack_public_path__ + "img/icon-ywqn-item-3.e1887b50.png";